import { useRef, useState } from "react";
import SiteVisitGrid from "./SiteVisitGrid";
import SiteVisitTimeGrid from "./SiteVisitTimeGrid";

export default function SiteVisits(props) {
  const { sales } = props;

  const siteVisitTimeGridRef = useRef(null);

  const [siteVisitFullScreen, setSiteVisitFullScreen] = useState(false);
  const [siteVisitTimeFullScreen, setSiteVisitTimeFullScreen] = useState(false);

  return (
    <div
      className={`container${
        siteVisitFullScreen || siteVisitTimeFullScreen ? `-full-screen` : ``
      }`}
    >
      <div className={`box${siteVisitTimeFullScreen ? `-full-screen` : ``}`}>
        <SiteVisitGrid
          sales={sales}
          siteVisitTimeGridRef={siteVisitTimeGridRef}
          siteVisitFullScreen={siteVisitFullScreen}
          setSiteVisitFullScreen={setSiteVisitFullScreen}
        />
      </div>
      <div className={`box${siteVisitFullScreen ? `-full-screen` : ``}`}>
        <SiteVisitTimeGrid
          sales={sales}
          siteVisitTimeGridRef={siteVisitTimeGridRef}
          siteVisitTimeFullScreen={siteVisitTimeFullScreen}
          setSiteVisitTimeFullScreen={setSiteVisitTimeFullScreen}
        />
      </div>
    </div>
  );
}
